import React from 'react';

import { Container } from '~shared/components/Container/Container';
import { Divider } from '~shared/components/Divider';
import { useCopyDialog } from '~teacher/components/quizzes/CopyMoveDialog/CopyToWorkspaceDialog/CopyToWorkspaceContext';
import { useWorkspaceList } from '~teacher/hook/workspaces';
import { WorkspaceRow } from '~teacher/launchv2/steps/SelectWorkspace';

export const SelectWorkspace = () => {
  const { nextStep, setWorkspace } = useCopyDialog();
  const { data } = useWorkspaceList();
  if (!data) return <>loading...</>;
  return (
    <Container width={1}>
      <div>
        {data.map((item) => {
          return (
            <div key={item.id}>
              <WorkspaceRow
                item={item}
                onSelect={(name, id) => {
                  setWorkspace({ id, name });
                  nextStep();
                }}
                key={item.id}
              />
              <Divider />
            </div>
          );
        })}
      </div>
    </Container>
  );
};
